import { render } from "./detail.vue?vue&type=template&id=20b9b64c&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=20b9b64c&media=printMe&lang=css"
import "./detail.vue?vue&type=style&index=1&id=20b9b64c&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b9b64c"]])

export default __exports__